import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseSection from './components/WhyChooseSection';
import ProcessSection from './components/ProcessSection';
import PricingSection from './components/PricingSection';
import IndustriesSection from './components/IndustriesSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';

// Home Page Component
function HomePage({ onOpenForm }) {
  return (
    <>
      <Helmet>
        <title>Professional Trademark Registration Services | USPTO Filing Experts</title>
        <meta 
          name="description" 
          content="Expert trademark registration services with 95% approval rate. Comprehensive USPTO filing, trademark search, office action response, and brand protection. Over 1000+ trademarks filed successfully." 
        />
        <meta 
          name="keywords" 
          content="trademark registration, USPTO filing, trademark search, brand protection, business name trademark, logo trademark, trademark attorney, trademark application" 
        />
        <meta property="og:title" content="Professional Trademark Registration Services | USPTO Filing Experts" />
        <meta property="og:description" content="Expert trademark registration services with 95% approval rate. Comprehensive USPTO filing, trademark search, and brand protection." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://registerbusinessnametrademark.com/" />
      </Helmet>
      
      <Header onOpenForm={onOpenForm} />
      
      <main>
        {/* 1. Hero Section */}
        <HeroSection onOpenForm={onOpenForm} />
        
        {/* 2. About Section */}
        <AboutSection />
        
        {/* 3. Trademark Overview + 4. Services Section */}
        <ServicesSection onOpenForm={onOpenForm} />
        
        {/* 5. Why Choose Us */}
        <WhyChooseSection onOpenForm={onOpenForm} />
        
        {/* 6. Process Section */}
        <ProcessSection onOpenForm={onOpenForm} />
        
        {/* 7. Pricing Section */}
        <PricingSection onOpenForm={onOpenForm} />
        
        {/* 8. Industries + 9. Benefits */}
        <IndustriesSection />
        
        {/* 10. Trust Section */}
        <TrustSection onOpenForm={onOpenForm} />
        
        {/* 11. FAQ Section */}
        <FAQSection />
        
        {/* 12. CTA Section */}
        <CTASection onOpenForm={onOpenForm} />
        
        {/* 13. Contact Section */}
        <ContactSection onOpenForm={onOpenForm} />
      </main>
      
      {/* 14. Footer */}
      <Footer onOpenForm={onOpenForm} />
    </>
  );
}

function App() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App">
          <Toaster position="top-right" richColors />
          
          <Routes>
            {/* Home Page */}
            <Route path="/" element={<HomePage onOpenForm={openForm} />} />
            
            {/* Privacy Policy Page */}
            <Route path="/privacy-policy" element={<PrivacyPolicy onOpenForm={openForm} />} />
            
            {/* Terms & Conditions Page */}
            <Route path="/terms-conditions" element={<TermsConditions onOpenForm={openForm} />} />
          </Routes>
          
          {/* Contact Form Popup */}
          <ContactForm isOpen={isFormOpen} onClose={closeForm} />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
